import React, { useEffect, useState } from "react";

import { getBrandLogoUrl } from "./logoUrls";

export default function BrandLogoImage({
  brand,
  alt,
  title,
  className,
  style,
  fallback = null,
}) {
  const logoUrl = getBrandLogoUrl(brand);
  const [failedUrl, setFailedUrl] = useState(null);

  useEffect(() => {
    setFailedUrl(null);
  }, [logoUrl]);

  if (!logoUrl || failedUrl === logoUrl) {
    return fallback;
  }

  return (
    <img
      alt={alt || brand || ""}
      title={title}
      className={className}
      style={style}
      src={logoUrl}
      onError={() => setFailedUrl(logoUrl)}
    />
  );
}
